import type { AssetLogListItem } from '@evimo/types/api/goldenRecord/find-asset-logs/find-asset-logs.response.dto';
import { summarizeAssetLogContent } from '~/app/components/asset-detail/assetLogContent.utils';

export function filterAssetLogsByQuery(
  logs: readonly AssetLogListItem[],
  normalizedQuery: string,
): AssetLogListItem[] {
  if (!normalizedQuery) {
    return [...logs];
  }

  return logs.filter((log) => {
    const summary = summarizeAssetLogContent(log.rawLog);
    return [
      log.logId,
      log.receivedAt,
      log.createdAt,
      summary.action,
      summary.uniqueId,
      summary.connectorId,
      summary.source,
      summary.frameType,
      summary.direction,
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase()
      .includes(normalizedQuery);
  });
}
